/*
 * @Description: 
 * @Autor: dongliangke
 * @Date: 2023-07-20 17:26:20
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-12-06 11:07:33
 */
import { RouteRecordRaw } from 'vue-router'
let routerpath = '/';
// 兼容微前端路由
if ((window as any).__POWERED_BY_QIANKUN__) {
  routerpath = '/micro-app/process-portal/'
}
// 仅保留菜单下的 4 个 cls 页面，通过 index.html?cls=xxx 加载
const childrens: RouteRecordRaw[] = []

// 基础路由
export const constantRouterMap: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "views/login" */ '@/views/login/login.vue')
  },
  {
    path: '/',
    redirect: { path: '/index.html', query: { cls: 'data-task-management' } },
    component: () => import(/* webpackChunkName: "views/layout" */ '@/views/layout/index.vue'),
    children: childrens
  },
  {
    path: '/index.html',
    name: 'index-html',
    component: { template: '<div></div>' },
    meta: { title: '首页' }
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/* webpackChunkName: "views/403" */ '@/views/error-pages/403.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "views/404" */ '@/views/error-pages/404.vue')
  },
  {
    path: '/500',
    name: '500',
    component: () => import(/* webpackChunkName: "views/500" */ '@/views/error-pages/500.vue')
  },
  // /biz 路径重定向到 index.html?cls=xxx（兼容旧链接）
  {
    path: '/biz/data-task-management',
    redirect: { path: '/index.html', query: { cls: 'data-task-management' } }
  },
  {
    path: '/biz/financial-data-maintenance',
    redirect: { path: '/index.html', query: { cls: 'financial-data-maintenance' } }
  },
  {
    path: '/biz/brand-mapping-maintenance',
    redirect: { path: '/index.html', query: { cls: 'brand-mapping-maintenance' } }
  },
  {
    path: '/biz/data-maintenance',
    redirect: { path: '/index.html', query: { cls: 'data-maintenance' } }
  },
  {
    path: "/:pathMatch(.*)",
    redirect: '/404'
  }
]
// 微前端路由 
export const microRouterMap: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { path: '/micro-app/process-portal/index.html', query: { cls: 'data-task-management' } },
    component: () => import(/* webpackChunkName: "views/layout" */ '@/views/layout/index.vue'),
    children: childrens
  },
  {
    path: '/micro-app/process-portal/index.html',
    name: 'index-html',
    component: { template: '<div></div>' },
    meta: { title: '首页' }
  },
  // 微前端 /biz 路径重定向到 index.html?cls=xxx
  {
    path: '/micro-app/process-portal/biz/data-task-management',
    redirect: { path: '/micro-app/process-portal/index.html', query: { cls: 'data-task-management' } }
  },
  {
    path: '/micro-app/process-portal/biz/financial-data-maintenance',
    redirect: { path: '/micro-app/process-portal/index.html', query: { cls: 'financial-data-maintenance' } }
  },
  {
    path: '/micro-app/process-portal/biz/brand-mapping-maintenance',
    redirect: { path: '/micro-app/process-portal/index.html', query: { cls: 'brand-mapping-maintenance' } }
  },
  {
    path: '/micro-app/process-portal/biz/data-maintenance',
    redirect: { path: '/micro-app/process-portal/index.html', query: { cls: 'data-maintenance' } }
  }
]

// 白名单(路径) - index.html 用于独立嵌入访问，如 index.html?cls=tender-risk-customer-list
export const whiteList = ['/login', '/403', '/404', '/500']